import tokenData from '../../design-tokens/base-tokens.json';
const MuiSwitch = {
    defaultProps: {
        disableRipple: true,
        size: 'small'
    },
    styleOverrides: {
        root: ({ ownerState }) => ({
            padding: 4,
            ...(!ownerState.disabled && {
                '&:hover': {
                    outlineStyle: 'solid',
                    outlineWidth: '2px',
                    outlineColor: tokenData.tokens.palette.blue.blue500,
                    borderRadius: 24
                }
            }),
            '&:focus-within': {
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.blue.blue500,
                borderRadius: 24
            }
        }),
        switchBase: {
            paddingLeft: 7,
            '&:hover': {
                backgroundColor: 'transparent',
                '&.Mui-checked': {
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-checked': {
                transform: 'translateX(25px)'
            },
            '&.Mui-disabled': {
                '& .MuiSwitch-thumb': {
                    boxShadow: 'unset'
                }
            }
        },
        track: {
            border: `1px solid ${tokenData.tokens.palette.grey.grey500}`,
            borderRadius: 16,
            backgroundColor: tokenData.tokens.palette.grey.grey300,
            opacity: 1,
            '&:before, &:after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 16,
                height: 20
            },
            '&:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="16" fill="${encodeURIComponent(`${tokenData.tokens.palette.background.white}`)}" viewBox="0 0 24 24"><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" /></svg>')`,
                left: 8
            },
            '.Mui-disabled.Mui-disabled + &': {
                opacity: 1,
                backgroundColor: tokenData.tokens.palette.grey.disabled,
                border: 0,
                cursor: 'not-allowed'
            },
            '.Mui-checked.Mui-checked + &:not(.Mui-disabled.Mui-disabled + &)': {
                opacity: 1,
                backgroundColor: tokenData.tokens.palette.blue.blue500,
                border: `1px solid ${tokenData.tokens.palette.blue.blue500}`
            }
        },
        thumb: {
            backgroundColor: tokenData.tokens.palette.background.white,
            width: 16,
            height: 16,
            margin: 2
        },
        sizeSmall: {
            padding: '2px 1px',
            outlineOffset: '2px',
            '& .MuiSwitch-switchBase': {
                padding: 6
            },
            '& .MuiSwitch-thumb': {
                width: 12,
                height: 12,
                margin: 0
            },
            '& .MuiSwitch-track': {
                '&:before, &:after': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 12,
                    height: 21
                },
                '&:before': {
                    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="21" width="12" fill="${encodeURIComponent(`${tokenData.tokens.palette.background.white}`)}" viewBox="0 0 24 24"><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" /></svg>')`,
                    left: 5
                }
            }
        }
    }
};
export default MuiSwitch;
